import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { syncPendingTimesheets } from './timeSheet.slice';

interface SyncState {
  isOnline: boolean;
  lastSynced: string | null;
  isSyncing: boolean;
  error: string | null;
  pendingCount: number;
}

const initialState: SyncState = {
  isOnline: navigator.onLine,
  lastSynced: null,
  isSyncing: false,
  error: null,
  pendingCount: 0
};

const syncSlice = createSlice({
  name: 'sync',
  initialState,
  reducers: {
    setOnlineStatus: (state, action: PayloadAction<boolean>) => {
      state.isOnline = action.payload;
    },
    setPendingCount: (state, action: PayloadAction<number>) => {
      state.pendingCount = action.payload;
    },
    resetSyncError: (state) => {
      state.error = null;
    },
    reset: (state) => {
      state.isOnline = navigator.onLine;
      state.lastSynced = null;
      state.isSyncing = false;
      state.error = null;
      state.pendingCount = 0;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(syncPendingTimesheets.pending, (state) => {
        state.isSyncing = true;
        state.error = null;
      })
      .addCase(syncPendingTimesheets.fulfilled, (state) => {
        state.isSyncing = false;
        state.lastSynced = new Date().toISOString();
      })
      .addCase(syncPendingTimesheets.rejected, (state, action) => {
        state.isSyncing = false;
        state.error = action.error.message || 'Sync failed';
      });
  }
});

export const { setOnlineStatus, setPendingCount, resetSyncError, reset } = syncSlice.actions;
export default syncSlice.reducer;